import { useEffect } from 'react';

const HEADER_BACK_EVENT = 'myungchisa:header-back';

/** 본문 뒤로가기 제거 뒤에도 폼의 나가기 확인·임시저장 안내를 앱 헤더에서 유지한다. */
export const useHeaderBackAction = (onBack: () => void): void => {
    useEffect(() => {
        const handler = (event: Event): void => {
            event.preventDefault();
            onBack();
        };
        window.addEventListener(HEADER_BACK_EVENT, handler);
        return () => window.removeEventListener(HEADER_BACK_EVENT, handler);
    }, [onBack]);
};

/** true이면 현재 페이지가 뒤로가기를 처리했다. */
export const handlePageHeaderBack = (): boolean =>
    !window.dispatchEvent(new Event(HEADER_BACK_EVENT, { cancelable: true }));
